import { LIVE_TICK_MS } from '@mixwire/contracts';
import { useEffect, useState } from 'react';

// Ticks elapsed ms since the current sample landed, smoothing the display between slow polls.
// Resets on a new sample (by identity) and holds still while paused, so it can't drift from the real position.
export const useLiveProgress = (sample: unknown, isAdvancing: boolean): number => {
  const [ticks, setTicks] = useState(0);
  const [seen, setSeen] = useState(sample);

  if (sample !== seen) {
    setSeen(sample);
    setTicks(0);
  }

  useEffect(() => {
    if (!isAdvancing) {
      return;
    }

    const timer = setInterval(() => {
      setTicks((tick) => tick + 1);
    }, LIVE_TICK_MS);
    return (): void => {
      clearInterval(timer);
    };
  }, [sample, isAdvancing]);

  return ticks * LIVE_TICK_MS;
};
